import styled from "styled-components";

export const LoginFormStyled = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 1.9rem;

  & .MuiFormControl-root {
    padding: 0;
    gap: 1rem;
  }

  & .MuiTextField-root {
    max-width: 45.2rem;
    border-radius: 0.8rem;
  }

  & .MuiFormHelperText-root {
    font-family: "Inter", sans-serif;
    padding: 0;
    margin: 0;
    font-size: 1.2rem;
    line-height: 150%;
  }

  & input {
    height: 6rem;
    padding: 0 1.5rem;
    background-color: var(--color-grey-0);
    font-size: 1.2rem;
  }

  & input:focus {
    background-color: var(--background);
  }

  & label {
    top: 0.4rem;
    left: -0.1rem;
    font-size: 1.2rem;
    font-weight: 400;
    line-height: 1.452rem;
    font-family: "Inter", sans-serif;
  }

  & input::placeholder {
    font-size: 1.2rem;
  }
`;
